import { useSelector, useDispatch } from "react-redux";
import { Wrapper, Circle, Back } from "./LessonsRangeStyle";
import { updateCurrentLesson } from "../../../../features/lessons/lessonSlice";

const LessonsRange = () => {
  const dispatch = useDispatch();

  const role = useSelector((s) => s.auth?.user?.role); // ✅ add
  const isPrivileged = role === "TEACHER" || role === "ADMIN"; // ✅ add

  const start = Number(useSelector((state) => state.lesson.lessonsRange));
  const { lessons } = useSelector((state) => state.studentLessons);

  const lessonsNumber = Array.from({ length: 6 }, (_, i) => start + i);

  const isLessonUnlocked = (lessonNumber) => {
    if (isPrivileged) return true; // ✅ bypass
    const lesson = lessons.find((l) => l.order === lessonNumber);
    return !!lesson?.isUnlocked;
  };

  const clickCircle = (e) => {
    const lessonNumber = Number(e.target.id);
    if (!isLessonUnlocked(lessonNumber)) {
      // locked → do nothing
      return;
    }
    dispatch(updateCurrentLesson(lessonNumber));
  };

  return (
    <Wrapper>
      {lessonsNumber.map((value) => {
        const unlocked = isLessonUnlocked(value);

        return (
          <div key={value}>
            <Circle
              id={value}
              onClick={clickCircle}
              data-locked={unlocked ? "false" : "true"}
            >
              {value}
            </Circle>
          </div>
        );
      })}
      <Back to="/myprogress/">BACK</Back>
    </Wrapper>
  );
};

export default LessonsRange;
